export interface PreQCPSignpostingProps {
  quotedProduct: QuotedProduct;
  journeyCurrentPagePath: string;
  journeyToken: string;
  authenticityToken: string;
  secondaryProduct: SecondaryProduct;
}

export interface QuotedProduct {
  name: string;
  min_price?: string;
  hyperlink_text: string;
}

export interface SecondaryProduct {
  name: string;
  min_price?: string;
  text: string;
}

export const PreQCPSignposting = ({
  quotedProduct,
  journeyCurrentPagePath,
  journeyToken,
  authenticityToken,
  secondaryProduct,
}: PreQCPSignpostingProps) => {
  return (
    <div className="mobius-pre-qcp__pre-qcp-card-container">
      <div className="mobius-pre-qcp__additional-rfq-body">
        <div className="mobius-pre-qcp__pre-qcp-primary">
          <h2 className="mobius-pre-qcp__quoted-product-name">
            {quotedProduct.name}
          </h2>
          {quotedProduct.min_price && (
            <div className="mobius-pre-qcp__quoted-subtext">
              From <span>{quotedProduct.min_price}</span> / month
            </div>
          )}
          <div className="mobius-pre-qcp__button-container">
            <form action={journeyCurrentPagePath} method="post">
              <input
                type="hidden"
                name="authenticity_token"
                value={authenticityToken}
                autoComplete="off"
              />
              <input
                type="hidden"
                name="journey_token"
                id="journey_token"
                value={journeyToken}
                autoComplete="off"
              />
              <button
                id="btn-submit"
                type="submit"
                className="mobius --variant-primary --size-sm mobius-button btn-primary explanation-btn"
              >
                {quotedProduct.hyperlink_text}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="mobius-pre-qcp__additional-rfq-body">
        <h2 className="mobius-pre-qcp__quoted-product-name">
          {secondaryProduct.name}
        </h2>
        {secondaryProduct.min_price && (
          <div className="mobius-pre-qcp__quoted-subtext">
            From <span>{secondaryProduct.min_price}</span> / month
          </div>
        )}
        <div className="mobius-pre-qcp__pre-qcp-continuation-subtext">
          {secondaryProduct.text}
        </div>
      </div>
    </div>
  );
};
